import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer/Footer";
import "./Home.scss";

interface HomeProps {
  children: ReactNode;
}

const Home: React.FC<HomeProps> = ({ children }) => {
  const [footerHeight, setFooterHeight] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    const footerEl = document.getElementById("app-footer");
    const headerEl = document.getElementById("app-header");

    const updateHeights = () => {
      setFooterHeight(footerEl?.offsetHeight || 0);
      setHeaderHeight(headerEl?.offsetHeight || 0);
    };

    // Run once on mount
    updateHeights();

    // Observe resizes
    const resizeObserver = new ResizeObserver(updateHeights);

    if (footerEl) resizeObserver.observe(footerEl);
    if (headerEl) resizeObserver.observe(headerEl);

    // Fallback for window resize too
    window.addEventListener("resize", updateHeights);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateHeights);
    };
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expiresAt");
    navigate("/login");
  };

  return (
    <div className="main-container">
      {/* Header */}
      {!isLoginPage && (
        <div
          id="app-header"
          className="logo-container branding-container apimatic-background-color"
        >
          <div className="logo-left">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img
                src="./static/images/goe.png"
                alt="logo"
                className="logo-image"
              />
            </a>
            <div className="divider apimatic-border-color"></div>
            <h4 className="apimatic-text-color logo-text">
              GOE Developer Hub
            </h4>
          </div>
          <button onClick={handleSignOut} className="signout-button">
            Sign Out
          </button>
        </div>
      )}

      {/* Main content (widget container) */}
      <div
        id="widget-container"
        className="main"
        style={{
          height: `calc(100vh - ${footerHeight + (isLoginPage ? 0 : headerHeight)}px)`,
          overflow: "hidden",
        }}
      >
        {children}
      </div>

      {/* Footer */}
      <Footer id="app-footer" />
    </div>
  );
};

export default Home;
